import { Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { fr } from "@/i18n/fr";
import { AccountMenu } from "./AccountMenu";
import { ThemeToggle } from "./ThemeToggle";
import { Wordmark } from "./Wordmark";

interface SiteHeaderProps {
	/** Replace the wordmark by a back link (the login page). */
	back?: "/";
	/** Over the ink hero: transparent, light text, no border. */
	onInk?: boolean;
}

/** Header of the pages that are not the viewer: wordmark, theme, account. */
export function SiteHeader({ back, onInk }: SiteHeaderProps) {
	return (
		<header
			className={
				onInk
					? "absolute inset-x-0 top-0 z-10 text-on-ink"
					: "sticky top-0 z-10 bg-bg/90 backdrop-blur"
			}
		>
			<div className="mx-auto flex h-14 max-w-6xl items-center gap-2 px-4 md:h-16 md:gap-4 md:px-6">
				{back ? (
					<Link
						to={back}
						className={`pill no-underline ${onInk ? "border-on-ink/20 bg-on-ink/10 text-on-ink shadow-none hover:border-on-ink/40 hover:text-on-ink" : ""}`}
					>
						<ChevronLeft aria-hidden="true" />
						{fr.home}
					</Link>
				) : (
					<Wordmark onInk={onInk} />
				)}
				<div className="ml-auto flex items-center gap-2 md:gap-4">
					<ThemeToggle onInk={onInk} />
					{!back && <AccountMenu onInk={onInk} />}
				</div>
			</div>
		</header>
	);
}
